export const userInteractions = {
  acknowledgeCase: "ACKNOWLEDGE_CASE",
  closeAlertWindow: "CLOSE_ALERT_WINDOW",
  showCaseDetails: "SHOW_CASE_DETAILS",
  silenceAlert: "SILENCE_ALERT",
  silenceCase: "SILENCE_CASE",
};
